import React from 'react';
import styled from "styled-components";
import {linkColor, gray900} from "../shared/themes/color";
import { Link } from 'react-router-dom';

const MainContainer = styled.div`
  display: flex;
  margin: auto;
`;

const JonMinimal = styled.span`
  height: fit-content;
  font-style: normal;
  font-weight: 500;
  font-size: 2rem;
  line-height: 1;
  text-align: right;
  color: ${gray900};

  :after {
    content: '\\A Minimal';
    white-space: pre;
  }
`;

const NavContainer = styled.div`
  margin-top: 5.25rem;
`;

const Option = styled(Link)`
  ${linkColor};
  display: flex;
  margin-bottom: 1.25rem;
  font-style: normal;
  font-weight: normal;
  font-size: 1.25rem;
  text-decoration: none;
  line-height: 1.5rem;
  cursor: pointer;

  :hover {

    :before {
      opacity: 1;
      transform: translateX(0);
    }
  }

  :before {
    content: 'chevron_right';
    font-family: 'Material Icons', sans-serif;
    font-size: 1.5rem;
    opacity: 0;
    transform: translateX(-.5rem);
    transition: all 200ms ease-in-out;
  }
`;

export const NavOption = ({label, route}) => {
  return (
    <Option to={route || '/'}>{label || 'label'}</Option>
  );
};

const Home = () => {
  return (
    <MainContainer>
      <JonMinimal>Jon</JonMinimal>
      <NavContainer>
        <NavOption label='Perfil' route='/profile'/>
        <NavOption label='Evidencias' route='/evidencias/todas'/>
        <NavOption label='Contacto' route='/contacto'/>
      </NavContainer>
    </MainContainer>
  );
};

export default Home;
